import { TODO } from '@b2b/types/core';
import angular, { IScope } from 'angular';
import { CustomFieldsDetailDirectiveModule } from './detail/detail.directive';
import { CustomFieldsEditDirectiveModule } from './edit/edit.directive';

export const CustomFieldsDirectiveModule = angular
  .module('acme.common.directive.customFields', [CustomFieldsEditDirectiveModule, CustomFieldsDetailDirectiveModule])
  .directive('customFields', [
    function CustomFieldsDirective() {
      return {
        restrict: 'A',
        replace: true,
        templateUrl: 'common/directives/customFields/customFields.tpl.html',
        scope: {
          init: '=',
          mode: '@',
          max: '=',
          fields: '=',
        },

        link: function ($scope, $element, $attrs) {
          // Modified after controller runs
        },

        controller: [
          '$scope',
          function CustomFieldsController(
            $scope: IScope & { init: TODO; fields: TODO; mode: TODO; customFields: TODO }
          ) {
            $scope.customFields = {
              fields: [],

              init: function () {
                const initWatcher = $scope.$watch('init', function (n, o) {
                  if ($scope.init instanceof Array && $scope.init.length > 0) {
                    // Init fields after listener is set
                    console.log('CustomFields::init', $scope.init);
                    for (let i = $scope.init.length, ii = 0; i >= ii; i--) {
                      if (!$scope.init[i]) {
                        $scope.init.splice(i, 1);
                      }
                    }
                    $scope.customFields.fields = angular.copy($scope.init);
                    initWatcher();
                  }
                });

                $scope.$on('$destroy', function () {
                  initWatcher();
                });

                // Wait for init to begin assigning fields
                $scope.$on(
                  '$destroy',
                  $scope.$watchCollection('customFields.fields', function (n, o) {
                    console.log('CustomFields::watch', $scope.init);
                    $scope.fields = $scope.customFields.fields;
                  })
                );
              },

              isMode: function (mode) {
                return $scope.mode === mode;
              },
            };

            $scope.customFields.init();
          },
        ],
      };
    },
  ]).name;
